import { useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import { ScrollView, View } from 'react-native';

import { AdminModeHeader } from '@/components/admin-mode-header';
import { AdminBroadcastsScreen } from '@/components/admin-broadcasts-screen';
import { MemberHeaderBar } from '@/components/member-header-bar';
import { useTenant } from '@/components/tenant-provider';

export default function AdminBroadcastsRoute() {
  const { tenant } = useLocalSearchParams<{ tenant?: string }>();
  const { activeTenant } = useTenant();
  const scrollRef = React.useRef<ScrollView>(null);
  const [searchQuery, setSearchQuery] = React.useState('');
  const tenantSlug = tenant ?? activeTenant?.slug;

  return (
    <View className="flex-1 bg-background" collapsable={false}>
      <MemberHeaderBar
        mode="admin"
        onCreatePress={() => scrollRef.current?.scrollTo({ animated: true, y: 0 })}
        onSearchChange={setSearchQuery}
        searchPlaceholder="Search broadcasts"
      />
      <ScrollView
        ref={scrollRef}
        contentInsetAdjustmentBehavior="automatic"
        contentContainerClassName="gap-5 p-6 pb-28"
        keyboardShouldPersistTaps="handled"
        scrollEventThrottle={16}
      >
        <AdminModeHeader title="Broadcasts" />
        {tenantSlug ? (
          <AdminBroadcastsScreen searchQuery={searchQuery} tenantSlug={tenantSlug} />
        ) : null}
      </ScrollView>
    </View>
  );
}
